var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9998 27.5869C9.09579 22.8509 5.26779 18.5029 3.42779 14.8729C1.51779 11.1029 1.75379 8.14887 2.79979 6.10287C5.02779 1.75287 11.1998 0.558874 14.5658 4.01887L15.9998 5.49287L17.4338 4.01687C20.7998 0.556874 26.9718 1.75287 29.1998 6.10287C30.2478 8.14887 30.4818 11.1009 28.5718 14.8729C26.7298 18.5029 22.9038 22.8509 15.9998 27.5869Z","fill":"none","stroke":"#303030","strokeWidth":"2"}));
}

Heart.defaultProps = {"width":"28","height":"28","viewBox":"0 0 32 32"};

module.exports = Heart;

Heart.default = Heart;
